<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("heading.currencies") }}</v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="currencies"
      resName="currencies"
      class="table-row"
    >
      <template slot-scope="{ item }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-sm-center">{{ item.sign }}</td>
        <td class="text-sm-center">{{ item.code }}</td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="currencies"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
  </main>
</template>

<script>
export default {
  name: "Currencies",
  data() {
    return {
      headers: ["name", "sign", "code", "visible"]
    };
  },
  methods: {}
};
</script>
